var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative"}},[_c('div',{ref:_vm.refId,staticStyle:{"width":"100%","height":"100%"},attrs:{"datas":_vm.datas}})])
}
var staticRenderFns = []

export { render, staticRenderFns }